import TableWidgetSeparated from '@modul-connect/shared/components/molecules/tableWidget/tableWidgetSeparated.v2'
import ReportPage, { MissingServiceAllert } from '../reportPage.v2'
import { getTemplateColumns, getVehicleTemplateColumns} from './temperatureReportDetails/log_columns'
import Button from '@modul-connect/shared/components/atoms/button/button.v2'
import theme from '@modul-connect/shared/theme'
import { useEffect, useMemo, useRef, useState } from 'react'
import { CreateTemplateModal } from './createTemplateModal'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useAuth0 } from '@auth0/auth0-react'
import { applyClimateControlTemplateToVehicle, clearApplyClimateTemplateStatus, createClimateControlTemplate, getAllClimateControlTemplates, getVehiclesWithTemplate, removeClimateControlTemplate, removeClimateControlTemplateFromVehicle } from '../../../state/actions/vehicles'
import { SelectTemplateModal } from './selectTemplateModal'
import { VehicleTemplateDetails } from './vehicleTemplateDetails'
import { CustomModal2 } from '@modul-connect/shared/components/molecules/modal/customModal2'
import View from '@modul-connect/shared/components/atoms/view'
import { P } from '@modul-connect/shared/components/atoms/text'
import { showWarningNotification } from '../../../state/actions/app'
import { useTranslation } from 'react-i18next'
import { getServiceList } from '../../../utils/ServiceList'
import { ServiceType } from '@modul-connect/shared/utils/services'

const SettingsPage = ({ subtrees, selected_organisations }) => {
  const [openTemplateModal, setOpenTemplateModal] = useState(false)
  const [editing, setEditing] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedVehicleId, setSelectedVehicleId] = useState()
  const [templateSelectModalOpen, setTemplateSelectModalOpen] = useState(false)
  const [isDeletingVehicleTemplate, setIsDeletingVehicleTemplate] = useState(false)
  const [vehicleTemplateToRemove, setVehicleTemplateToRemove] = useState(null)
  const [templateToRemove, setTemplateToRemove] = useState(null)
  const [isTemplateUsedModalOpen, setIsTemplateUsedModalOpen] = useState(false)
  const [isDeletingTemplate, setIsDeletingTemplate] = useState(false)

  const disabled = !getServiceList({ subtrees }).hasServiceForSelected(selected_organisations, ServiceType.ClimateReports)

  const saving = useSelector(state => state.saving)
  const loading = useSelector(state => state.loading)

  const templates = useSelector(state => state.climateTemplates)

  const applyClimateTemplate = useSelector(state => state.saving.applyClimateTemplate || [])

  const vehicles = useSelector(state => state.vehiclesWithClimateTemplate)

  const selectedOrganisations = useSelector(state => state.selected_organisations)

  const subtreesFormatted = subtrees?.subtrees || [] 

  const dispatch = useDispatch()

  const { getAccessTokenSilently } = useAuth0()

  const hasAttemptedRemove = useRef(false)

  const {t} = useTranslation()

  const templateColumns = getTemplateColumns(t)
  const vehicleTemplateColumns = getVehicleTemplateColumns(t)

  const belongsToSelectedOrgs = (orgIds) => {
    if (!selectedOrganisations?.length) return true
    const ids = Array.isArray(orgIds) ? orgIds : [orgIds]
    return ids.some(id => id && selectedOrganisations.includes(id))
  }

  useEffect(() => {
    setSelectedRows([])
    getAccessTokenSilently()
      .then(token => {
        dispatch(getAllClimateControlTemplates(token))
        dispatch(getVehiclesWithTemplate(token))
      })
  }, [selectedOrganisations])

  useEffect(() => {
    const hasItems = applyClimateTemplate.length > 0
    const allDoneSaving = applyClimateTemplate.every(item => item.state !== 'saving')
    const noneFailed = applyClimateTemplate.every(item => item.state !== 'failed')
  
    if (hasItems && allDoneSaving && noneFailed) {
      handleCloseTemplateModal()
    }
  }, [applyClimateTemplate])

  useEffect(() => {
    if (openTemplateModal && saving.createClimateControlTemplate === null) {
      setOpenTemplateModal(false)
    }
  }, [saving.createClimateControlTemplate])

  const failedMainBoxIds = applyClimateTemplate
    .filter(item => item.state === 'failed')
    .map(item => item.id)

  const failedVehicleNames = vehicles
    .filter(vehicle => failedMainBoxIds.includes(vehicle.mainbox_id))
    .map(vehicle => vehicle.vehicleName)

  const createTemplate = (newTemplate) => {
    getAccessTokenSilently()
      .then(token => {
        dispatch(createClimateControlTemplate( 
          token, 
          newTemplate.name, 
          newTemplate.organizationId,
          newTemplate.organizationName,
          newTemplate.lowerWarningThreshold,
          newTemplate.upperWarningThreshold,
          newTemplate.lowerCriticalThreshold,
          newTemplate.upperCriticalThreshold,
          newTemplate.emailFrequency,
          newTemplate.emails,
          newTemplate.armedSchema
        ))
      })
  }

  const removeTemplateFromVehicle = (templateId, mainBoxId) => {
    getAccessTokenSilently()
      .then(token => {
        dispatch(removeClimateControlTemplateFromVehicle( 
          token, 
          templateId,
          mainBoxId
        ))
      })
  }

  const removeTemplate = (templateId, organisationId) => {
    getAccessTokenSilently()
      .then(token => {
        dispatch(removeClimateControlTemplate( 
          token, 
          templateId,
          organisationId
        ))
      })
  }

  const handleRemoveTemplate = (templateRow) => {
    const isTemplateUsed = vehicles.some(
      (v) => v.templateId === templateRow.id
    )

    setTemplateToRemove(templateRow)
  
    if (isTemplateUsed) {
      setIsTemplateUsedModalOpen(true)
    } else {
      setIsDeletingTemplate(true)
    }
  }

  useEffect(() => {
    if (saving.removeTemplate === 'saving' || saving.removeTemplateFromVehicle === 'saving' ) {
      hasAttemptedRemove.current = true
    }
  }, [saving.removeTemplate, saving.removeTemplateFromVehicle ])

  useEffect(() => {
    const status = saving.removeTemplateFromVehicle
    if (!hasAttemptedRemove.current) return 
  
    if (status === null) {
      dispatch(showWarningNotification('Template was successfully removed from vehicle.', 'success'))
      hasAttemptedRemove.current = false 
    } 
    if (status === 'failed') {
      dispatch(showWarningNotification('Failed to remove template from vehicle.', 'error'))
      hasAttemptedRemove.current = false

    }
  }, [saving.removeTemplateFromVehicle])
  

  useEffect(() => {
    const status = saving.removeTemplate
    if (!hasAttemptedRemove.current) return 
    if (status === null) {
      dispatch(showWarningNotification('Template was successfully removed.', 'success'))
      hasAttemptedRemove.current = false 
    } 
    if (status === 'failed') {
      dispatch(showWarningNotification('Failed to remove template.', 'error'))
      hasAttemptedRemove.current = false
    }
  }, [saving.removeTemplate])


  const handleApplyTemplate = (templateId, templateName) => {
    getAccessTokenSilently()
      .then(token => {
        if(selectedVehicleId) {
          dispatch(applyClimateControlTemplateToVehicle(token, templateId, selectedVehicleId, templateName))
        } 
        if(selectedRows.length > 0){
          selectedRows.forEach(mainBoxId => {
            dispatch(applyClimateControlTemplateToVehicle(token, templateId, mainBoxId, templateName))
          })
          setSelectedRows([])
        }
      })
  }

  //function for new command for adding to multiple vehicles (notworking in backend yet)

  // const handleApplyTemplate = (templateId, templateName) => {
  //   getAccessTokenSilently()
  //     .then(token => {
  //       dispatch(applyClimateControlTemplateToVehicle(token, templateId, selectedRows, templateName))
  //       setSelectedRows([])
  //     })
  // }
  const handleCloseTemplateModal = () => {
    dispatch(clearApplyClimateTemplateStatus())
    setTemplateSelectModalOpen(false)
  }

  const vehicleData = useMemo(() => {
    return vehicles
      .filter(vehicle => belongsToSelectedOrgs(vehicle.organisations || []))
      .map(vehicle => {
        const organizationNames = (vehicle.organisations || [])
          .map(orgId => subtreesFormatted.find(sub => sub.uuid === orgId)?.name)
          .filter(Boolean) 

        const templateData = templates.find(temp => temp.templateId === vehicle.templateId)

        return {
          id: vehicle.mainbox_id,
          mainBoxId: vehicle.mainbox_id,  
          vehicleName: vehicle.vehicleName ?? vehicle.baseVehicleName,
          templateName: vehicle.templateName,
          organisation: organizationNames.join(', '),
          isExpandable: true, 
          onExpand: () => {
          },
          collapsibleComponent: <VehicleTemplateDetails onDelete={() => {
            setVehicleTemplateToRemove({
              templateId: vehicle.templateId,
              mainBoxId: vehicle.mainbox_id
            })
            setIsDeletingVehicleTemplate(true)
          }} mainBoxId={vehicle.mainbox_id} template={templateData} setTemplateSelectModalOpen={setTemplateSelectModalOpen} setSelectedVehicleId={setSelectedVehicleId} />
        }
      })
  }, [vehicles, templates, subtreesFormatted, selectedOrganisations])

  const templatesData = useMemo(() => {
    return templates
      .filter(t => belongsToSelectedOrgs(t.organization))
      .map(t => ({
        id: t.templateId,
        templateName: t.name,
        organizationId: t.organization
      }))
  }, [templates, selectedOrganisations])
  const actionItems = 
  [
    {
      title: t('climateSystem.settings.addTemplate'),
      action: () => {
        if (selectedRows.length > 0) {
          setTemplateSelectModalOpen(true)
        }
      }
    }
  ]
  const templateTable = 
    <TableWidgetSeparated
      data={templatesData}
      columns={templateColumns}
      onDeleteButton={(row) => {
        handleRemoveTemplate(row)
      }}
      deleteButtonLabel={t('climateSystem.settings.template.delete')}
      deleteButtonIcon="Delete"

      // Edit button funktionality- no support in backend yet

      // onEditButton={(row) => {
      //   setOpenTemplateModal(true)
      // }}
      // editButtonLabel={'Edit template'}
      // editButtonIcon="PencilBlue"
      totalItems={templatesData.length}
      themes={'themes'}
      isSortable
      defaultSort="templateName" 
      defaultSortOrder="asc"
    />
  
  const vehicleTable = 
    <TableWidgetSeparated
      data={vehicleData}
      columns={editing ? [
        {
          id: 'checkBox',
          label: ' ',
          width: 10,
          hide: [],
          align: 'left',
          hasCheckbox: true
        },
        ...vehicleTemplateColumns
      ]  
        : vehicleTemplateColumns}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      totalItems={vehicleData.length}
      themes={'themes'}
      isSortable
      defaultSort="vehicleName" 
      defaultSortOrder="asc"
    />
 
  return (
    <>
      {disabled ? <MissingServiceAllert /> : 
        <>
          <ReportPage
            title={t('climateSystem.settings.settings')}
            noSearch
            noFilterBar
            noHeader
            noTimePickerBar
            tables={vehicleTable}
            isLoading={loading.allClimateControlTemplates === 'loading'}
            actionItems={actionItems}
            editing={editing}
            setEditing={(newVal) => {
              setEditing(newVal)
              setSelectedRows([])
            }}
          >
          </ReportPage>
          <ReportPage
            title={t('climateSystem.settings.templates')}
            noSearch
            noFilterBar
            noHeader
            noTimePickerBar
            tables={templateTable}
            isLoading={loading.allClimateControlTemplates === 'loading'}
            button={
              <Button  extend={{ backgroundColor: 'transparent', color: theme.colors.blue }} onClick={() => setOpenTemplateModal(true)}>
          + {t('climateSystem.settings.addTemplate')}
              </Button>
            }
          ></ReportPage>
        </>
      }
      {openTemplateModal && (
        <CreateTemplateModal subtrees={subtreesFormatted} templateAlreadyExists={saving.createClimateControlTemplate === 'conflict'} addingFailed={saving.createClimateControlTemplate === 'failed'} disabled={saving.createClimateControlTemplate === 'saving'}  onSave={createTemplate} onClose={() => setOpenTemplateModal(false)} openModal={openTemplateModal} />
      )}
      {templateSelectModalOpen && (
        <SelectTemplateModal
          openModal={templateSelectModalOpen}
          onClose={handleCloseTemplateModal}
          templates={templatesData}
          onAdd={handleApplyTemplate}
          failedItems={failedVehicleNames}
          disabled={applyClimateTemplate.some(item => item.state === 'saving')}
        />
      )}
      <CustomModal2
        openModal={isDeletingVehicleTemplate}
        title={t('climateSystem.settings.confirmRemoveTemplate.title')}
        primaryButton={t('climateSystem.settings.confirmRemoveTemplate.confirm')}
        secondaryButton={t('cancel')}
        onSave={() => {
          if (vehicleTemplateToRemove) {
            removeTemplateFromVehicle(vehicleTemplateToRemove.templateId, vehicleTemplateToRemove.mainBoxId)
            setIsDeletingVehicleTemplate(false)
            setVehicleTemplateToRemove(null)
          }
        }}
        onCancel={() => setIsDeletingVehicleTemplate(false)}
        isPrimaryColor={false}
      >
        <View extend={{ '& strong': { fontWeight: 600 } }}>
          <P noPadding>{t('climateSystem.settings.confirmRemoveTemplate.message')}</P> 
        </View>
      </CustomModal2>

      <CustomModal2
        openModal={isTemplateUsedModalOpen}
        title={t('climateSystem.settings.cannotDeleteTemplate.title')}
        primaryButton="OK"
        onSave={() => setIsTemplateUsedModalOpen(false)}
        isPrimaryColor={false}
      >
        <View extend={{ '& strong': { fontWeight: 600 } }}>
          <P noPadding>{t('climateSystem.settings.cannotDeleteTemplate.message')}</P>
        </View>
      </CustomModal2>

      <CustomModal2
        openModal={isDeletingTemplate}
        title={t('climateSystem.settings.confirmRemoveTemplate.title')}
        primaryButton={t('climateSystem.settings.confirmRemoveTemplate.confirm')}
        secondaryButton={t('cancel')}
        onSave={() => {
          if (templateToRemove) {
            removeTemplate(templateToRemove.id, templateToRemove.organizationId)
            setIsDeletingTemplate(false)
            setTemplateToRemove(null)
          }
        }}
        onCancel={() => setIsDeletingTemplate(false)}
        isPrimaryColor={false}
      >
        <View extend={{ '& strong': { fontWeight: 600 } }}>
          <P noPadding>{t('climateSystem.settings.confirmRemoveTemplate.message')}</P>          
        </View>
      </CustomModal2>
    </>
  )
}

const mapStateToProps = props => props

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage)